import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import { ApproximateValueRepository } from '../../../domain/repository';
import fixtures from './fixtures.json';

@Injectable()
export default class ApproximateValueDummyRepository implements ApproximateValueRepository {
  findAll() {
    return Promise.resolve(fixtures);
  }
}
